import { render, staticRenderFns } from "./ed-forgot-password-popup.vue?vue&type=template&id=21e7c92e&scoped=true&"
import script from "./ed-forgot-password-popup.ts?vue&type=script&lang=js&"
export * from "./ed-forgot-password-popup.ts?vue&type=script&lang=js&"
import style0 from "./ed-forgot-password-popup.scss?vue&type=style&index=0&id=21e7c92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e7c92e",
  null
  
)

export default component.exports